export const INIT = 'TYPEAHEAD_INIT';
export const UPDATE_OPTIONS = 'TYPEAHEAD_UPDATE_OPTIONS';
export const UPDATE_SELECTED = 'TYPEAHEAD_UPDATE_SELECTED';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/TypeAheadSelect/TypeAheadSelectConstants.js